<template>
  <el-form ref="crawlerForm" :model="crawlerForm" :rules="crawlerRules" label-width="110px">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="设备型号" prop="deviceModel">
          <el-input
            v-if="!isDetail()"
            v-model="crawlerForm.deviceModel"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ crawlerForm.deviceModel || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="出厂编号" prop="factoryNo">
          <el-input
            v-if="!isDetail()"
            v-model="crawlerForm.factoryNo"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ crawlerForm.factoryNo || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="设备状态" prop="status">
          <el-select v-if="!isDetail()" v-model="crawlerForm.status" style="width: 100%">
            <el-option
              v-for="item in typeList"
              :key="item.type"
              :label="item.typeName"
              :value="item.type"
            ></el-option>
          </el-select>
          <span v-else>{{ typeObj[crawlerForm.status] || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      typeList: [
        { type: 0, typeName: '启用' },
        { type: 1, typeName: '停用' }
      ],
      typeObj: {
        0: '启用',
        1: '停用'
      },
      crawlerForm: {}
    };
  },
  inject: ['isDetail'],
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.crawlerForm = newVal;
      }
    },
    crawlerForm: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.$emit('change', newVal);
      }
    }
  },
  computed: {
    crawlerRules() {
      return {
        status: [{ required: !this.isDetail(), message: '请选择设备状态', trigger: 'change' }]
      };
    }
  },
  methods: {
    getNationNo() {
      // getNationNum().then(res => {
      //   if (!res.success) {
      //     return;
      //   }
      //   this.crawlerForm.mnNum = res.data
      // });
    },
    getData() {
      let data = {
        deviceModel: this.crawlerForm.deviceModel,
        factoryNo: this.crawlerForm.factoryNo,
        status: this.crawlerForm.status
      };
      return data;
    },
    setData(data) {
      const { deviceModel, factoryNo, status } = data;
      this.crawlerForm.deviceModel = deviceModel;
      this.crawlerForm.factoryNo = factoryNo;
      this.crawlerForm.status = status;
    },
    reset() {
      this.$refs.crawlerForm.resetFields();
    },
    validate() {
      let type;
      this.$refs.crawlerForm.validate(validated => {
        type = validated;
      });
      return type;
    }
  }
};
</script>
